export default __webpack_public_path__ + "static/media/industry-leading-funds.572a468b.png";